export const CONFIRMATION_DIALOG__DELETE_SITE = 'CONFIRMATION_DIALOG__DELETE_SITE';
